<span
  [class.sort-by-selected]="isSelected"
  [class.sort-by-asc]="sortOrder === 'asc'"
  [class.sort-by-desc]="sortOrder === 'desc'"
  (click)="onClick()"
>
  <ng-content></ng-content>
</span>
